import Vue from 'vue'
import Router from 'vue-router'
// import Loading from '../components/Loading'

export default function (config) {
  Vue.use(Router)

  return new Router({
    mode: 'hash',
    linkActiveClass: 'is-active',
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else {
        if (to.query.sxp) return // Skip scrollpos reset?
        return {y: 0, x: 0} // Reset scrollpos
      }
    },
    routes: [
      // {
      //   name: 'Loading',
      //   path: '/',
      //   component: Loading
      // }
    ]
  })
}
